import { EVENT_NAMES } from '@go-modules/services/event/event-names.constants';
import { EventService } from '@go-modules/services/event/event.service';
import { RouterService } from '@go-modules/services/router/router.service';

export class SessionInterceptor {
	public static responseError (
		response,
		sessionManager,
		eventService: EventService,
		routerService: RouterService
	) {
		// Handle the case where the user is not authenticated
		if (routerService.getCurrentRouteName()?.startsWith('root') && sessionManager.isEnded()) {
			eventService.broadcast(EVENT_NAMES.AUTH_ENDED);
		}

		return response;
	}
}
